// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"6be41bc9","787":"af891aa7","909":"187a4da1"}[chunkId] + ".chunk.js";
};